// extracted by mini-css-extract-plugin
module.exports = {"notAvailable":"SnapNotAvailable_notAvailable__swC0_","title":"SnapNotAvailable_title__LvTuW"};